<script setup lang="ts">
import { ref } from 'vue'
import Sidebar from './Sidebar.vue'

interface Props {
  showAdd?: boolean
  showBack?: boolean
}

withDefaults(defineProps<Props>(), {
  showAdd: false,
  showBack: false
})

const isSidebarCollapsed = ref(true)

const toggleSidebar = () => {
  isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const emit = defineEmits<{
  add: []
  navigate: [path: string]
  back: []
}>()

const handleNavigate = (path: string) => {
  emit('navigate', path)
}
</script>

<template>
  <div class="layout">
    <aside class="sidebar" :class="{ collapsed: isSidebarCollapsed }">
      <Sidebar :collapsed="isSidebarCollapsed" @navigate="handleNavigate" />
    </aside>
    
    <div class="main-container">
      <header class="header">
        <button class="toggle-btn" @click="toggleSidebar">
          <span class="icon">☰</span>
        </button>
        <div class="header-content">
          <slot name="header"></slot>
        </div>
        <button v-if="showBack" class="back-btn" @click="emit('back')" title="返回">
          <span class="icon">←</span>
        </button>
        <button v-else-if="showAdd" class="add-btn" @click="emit('add')" title="添加项目">
          <span class="icon">+</span>
        </button>
      </header>
      
      <main class="main-content">
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<style scoped>
.layout {
  display: flex;
  height: 100vh;
  width: 100vw;
}

.sidebar {
  width: 240px;
  background: #1a1a2e;
  color: #fff;
  transition: width 0.3s ease;
  flex-shrink: 0;
}

.sidebar.collapsed {
  width: 64px;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  flex-shrink: 0;
}

.toggle-btn {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background 0.2s;
}

.toggle-btn:hover {
  background: #f0f0f0;
}

.header-content {
  flex: 1;
  margin-left: 1rem;
}

.add-btn {
  background: #42b883;
  border: none;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, transform 0.2s;
  margin-left: 1rem;
}

.add-btn:hover {
  background: #369970;
  transform: scale(1.05);
}

.back-btn {
  background: #f0f0f0;
  border: none;
  color: #666;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, transform 0.2s;
  margin-left: 1rem;
}

.back-btn:hover {
  background: #e0e0e0;
  transform: scale(1.05);
}

.add-btn .icon {
  line-height: 1;
}

.main-content {
  flex: 1;
  overflow: auto;
  background: #f5f5f5;
}
</style>
